import { render } from "./ViewRegionsConfigs.vue?vue&type=template&id=39d84e33&scoped=true"
import script from "./ViewRegionsConfigs.vue?vue&type=script&lang=js"
export * from "./ViewRegionsConfigs.vue?vue&type=script&lang=js"

import "./ViewRegionsConfigs.vue?vue&type=style&index=0&id=39d84e33&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d84e33"]])

export default __exports__